module.exports = __webpack_public_path__ + "assets/images/correndo.4c7a8381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/correndo.jpg
// module id = 807
// module chunks = 1